import InfoIcon from '@mui/icons-material/InfoOutlined'
import { Drawer, Tooltip } from '@mui/material'
import IconButton from '@mui/material/IconButton'
import { useState } from 'react'
import ImageDetails from '../ImageDetails'
import PublicImageDetails from '../PublicImageDetails'

interface Props {
  ids: string[]
  onCompleted?: () => void
  color?: 'inherit' | 'primary' | 'secondary'
  isPublic?: boolean
}

export default function MediaDetails({ ids, color, onCompleted, isPublic }: Props) {
  const [open, setOpen] = useState(false)
  const toggleDrawer = () => {
    setOpen(!open)

    if (onCompleted) {
      onCompleted()
    }
  }

  const handleClose = () => {
    setOpen(false)
  }

  return (
    <>
      <IconButton
        aria-label="Media Details"
        color={color}
        onClick={toggleDrawer}
        disabled={ids.length !== 1}
        id="details-button"
        data-test="details-button"
      >
        <Tooltip title="Details" arrow>
          <InfoIcon />
        </Tooltip>
      </IconButton>
      <Drawer anchor="right" open={open} onClose={handleClose} PaperProps={{ sx: { width: '400px', maxWidth: '100%' } }}>
        {isPublic ? <PublicImageDetails id={ids[0]} onClose={toggleDrawer} /> : <ImageDetails id={ids[0]} onClose={toggleDrawer} />}
      </Drawer>
    </>
  )
}

MediaDetails.defaultProps = {
  color: 'inherit',
  onCompleted: undefined,
  isPublic: false
}
